var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 940.84 1217.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_4);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_4-4);\n      }\n\n      .cls-3 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_4-3);\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_5);\n        fill-rule: evenodd;\n      }\n\n      .cls-6 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_4-2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_4",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 4",
    x1: 251.02,
    y1: 919.85,
    x2: 527.74,
    y2: 987.74,
    gradientTransform: "translate(-873.58 3276.41) scale(3.4 -3.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01146a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b65ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_4-2",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 4",
    x1: 253.31,
    y1: 910.52,
    x2: 530.03,
    y2: 978.42,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_4-3",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 4",
    x1: 258,
    y1: 891.41,
    x2: 534.72,
    y2: 959.3,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_4-4",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 4",
    x1: 263.03,
    y1: 870.93,
    x2: 539.74,
    y2: 938.83,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_5",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 5",
    x1: 256.94,
    y1: 605.53,
    x2: 533.65,
    y2: 882.11,
    gradientTransform: "translate(-873.58 3276.41) scale(3.4 -3.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01146b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1a65ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169af8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5",
    className: "cls-1",
    d: "m28.51,0v98.48h2.81L173.73,0h48.22L61.66,110.83l171.21,120.02h-51.03L30.72,123.14h-2.21v107.71H0V0h28.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    className: "cls-6",
    d: "m434.05,0v25.87h-110.91v204.98h-28.51V25.87h-110.91V0h250.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    className: "cls-3",
    d: "m498.04,0v175.58h141.14v55.27h-209.89V0h68.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    className: "cls-2",
    d: "m818.23,0l122.61,230.85h-76.22l-21.36-38.47h-139.3l-21.57,38.47h-76.96L729.22,0h89.01Zm-88.78,137.34h87.73l-44.04-81.5-43.69,81.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9",
    className: "cls-5",
    d: "m0,1217.61V277.22h940.84v940.39H0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path10",
    className: "cls-4",
    d: "m799.46,831.45c0,178.48-146.9,323.17-328.11,323.17-181.22,0-328.13-144.68-328.13-323.17.04-14.87,1.12-29.72,3.24-44.45h171.37c-2.53,14.1-3.87,30.33-3.87,49.04,0,80.15,56.83,148.46,146.13,149.25,85.23.75,147.67-64.97,146.96-145.12-.82-91.69-63.36-145.14-146.96-145.14H187.39c53.83-113.87,156.43-186.7,283.96-186.75,181.21,0,328.11,144.69,328.11,323.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    className: "cls-4",
    d: "m741.76,343.69l-39.41,133.32-265.97-4.42c-126.58,0-230.63,104.2-230.63,104.2l78.87-234.87,457.13,1.77Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20);
export default __webpack_public_path__ + "static/media/20.9ed61398b476935dc3446e5cb08432f6.svg";
export { ForwardRef as ReactComponent };